module.exports = __webpack_public_path__ + "img/modernwide-black-frame-left-shadowed.d6416c73.png";